import HttpClient from './httpClient';

const restrictedPeriodsApi = {
  get: () => new HttpClient.Builder().get('/restricted-periods/').unsecured().execute(),
};

export default restrictedPeriodsApi;
